import { render, staticRenderFns } from "./EditGlass.vue?vue&type=template&id=15c3186c"
import script from "./EditGlass.vue?vue&type=script&lang=js"
export * from "./EditGlass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports